// src/app/api/notificationsApi.ts
// The header bell: GET /api/notifications (worked out on the server from
// feedback, messages, kits, payments, reviews and showcases).

import { baseApi } from "./baseApi";

export interface NotificationItem {
  id: string;
  title: string;
  body: string;
  to: string;
  tone: "info" | "action" | "urgent";
}

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getNotifications: b.query<{ success: boolean; data: { items: NotificationItem[]; count: number } }, void>({
      query: () => "/notifications",
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetNotificationsQuery } = notificationsApi;
